import { Modal, Button } from "react-bootstrap";
const ConfirmDeleteModal = ({ handleClose, handleDeleteSubmission }) => {
  return (
    <div>
      <Modal show={true} onHide={handleClose} dialogClassName="modal-dialog-centered">
        <Modal.Header className="text-center p-0 bg-primary">
          <Modal.Title
            style={{
              fontSize: "14px",
            }}
            className="mx-auto d-flex align-items-center justify-content-center height-25 font-weight-semibold text-uppercase popup-heading-color font-weight-500 h5"
          >
            Insurance
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "5px 5px" }}>
          <p>
            This will delete the insurance from the case and move any documents attached to this
            insurance to being unsorted attached to the case generally
          </p>
          <div className="d-flex justify-content-between mt-3">
            <Button
              variant="secondary"
              onClick={handleClose}
              className="height-25"
              style={{ padding: "0px 12px" }}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              onClick={handleDeleteSubmission}
              className="height-25"
              style={{ padding: "0px 12px" }}
            >
              Delete Insurance
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ConfirmDeleteModal;
